import React from "react";
import "./warning-text.scss";

const WarningText = (props) => {
  const { children, className } = props;
  return (
    <div className={`container ${className}`}>
      <div className="warning-text">
        {children}
        <span className="material-icons info warning-icon">warning</span>
      </div>
    </div>
  );
};

export default WarningText;